import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { I18nModule } from '../i18n/i18n.module';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    MatMenuModule,
    MatIconModule,
  ],
  exports: [
    HeaderComponent,
  ]
})
export class HeaderModule { }
